import React from 'react'
import AccountFormInput from '../../components/AccountFormInput'

const PasswordChangeSection = ({
  formData,
  handleInputChange,
  errors,
  passwordStrength,
  passwordMatch,
}) => (
  <div className="rounded-2xl border border-slate-200 shadow-sm p-4 sm:p-6 pb-8 mb-8">
    <h2 className="flex items-center gap-3 text-xl font-semibold text-slate-800 mb-6">
      პაროლის შეცვლა
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <AccountFormInput
          label="ახალი პაროლი"
          name="newPassword"
          type="password"
          value={formData.newPassword}
          onChange={handleInputChange}
        />
        {errors.new_password && (
          <p className="text-red-500 text-xs mt-1">
            პაროლი უნდა შედგებოდეს მინიმუმ 6 სიმბოლოსგან
          </p>
        )}
        {passwordStrength && !errors.new_password && (
          <div
            className={`mt-2 text-xs ${
              passwordStrength === 'weak'
                ? 'text-citrus-red'
                : passwordStrength === 'medium'
                ? 'text-yellow-500'
                : 'text-green-500'
            }`}
          >
            {passwordStrength === 'weak' && 'სუსტი პაროლი'}
            {passwordStrength === 'medium' && 'საშუალო პაროლი'}
            {passwordStrength === 'strong' && 'ძლიერი პაროლი'}
          </div>
        )}
      </div>
      <div>
        <AccountFormInput
          label="დაადასტურეთ პაროლი"
          name="confirmPassword"
          type="password"
          value={formData.confirmPassword}
          onChange={handleInputChange}
        />
        {errors.new_password_confirmation && (
          <p className="text-red-500 text-xs mt-1">
            {errors.new_password_confirmation}
          </p>
        )}
        {passwordMatch && !errors.new_password_confirmation && (
          <div
            className={`mt-2 text-xs ${
              passwordMatch === 'match' ? 'text-green-500' : 'text-citrus-red'
            }`}
          >
            {passwordMatch === 'match'
              ? 'პაროლები ემთხვევა'
              : 'პაროლები არ ემთხვევა'}
          </div>
        )}
      </div>
    </div>
  </div>
)

export default PasswordChangeSection
